import * as yup from "yup";

export const validationSchema = yup.object().shape({
  // Licence number validation
  licence_number: yup
    .string()
    .matches(
      /^[A-Z0-9\s]{10,20}$/,
      "Invalid licence number format (must be alphanumeric, allow spaces, 10-20 characters)"
    ) // Matches licence numbers like "TN62 20190001999"
    .required("Licence number is required"),
  address: yup
    .string()
    .required("Address is required") // Ensure address is provided
    .min(10, "Address must be at least 10 characters long") // Min length
    .max(200, "Address cannot exceed 200 characters"), // Max length
  licence_name: yup
    .string()
    .required("Licence name is required") // Ensure name is provided
    .min(3, "Licence name must be at least 3 characters") // Min length for name
    .max(50, "Licence name cannot exceed 50 characters"), // Max length for name
});
